import React, { FC } from 'react';
import { Button, Paper, Unstable_Grid2 as Grid } from '@mui/material';
import moment from 'moment';
import { isEqual } from 'lodash';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';

import { DatePickers } from 'components';
import { useDateRange } from 'hooks';
import { DateRange } from 'types/app';
import theme from 'theme';

import Filters from './Filters';

import { RangePickerWrapper } from 'features/admin/components/shared';
import { initialPostFilter, useSearchESContext } from 'features/search/SearchESContext';
import { Chips } from './index';

const styles = {
  toolbar: {
    border: 'none',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    position: 'fixed',
    zIndex: 600,
    width: '100%',
    padding: theme.spacing(1, 3),
  },
} as const;

const SearchFilterBar: FC = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useSearchESContext();

  const hasFilters = !isEqual(state.post_filter, initialPostFilter);
  const dateRangeOptions = useDateRange({ includeToday: true, defaultRange: DateRange.Last90Days });
  const { startDate, endDate, dateRange, setDateRange, setStartDate, setEndDate } =
    dateRangeOptions;

  let nextStartDate: string = null;
  let nextEndDate: string = null;

  function handleSetStartDate(date: string) {
    nextStartDate = date;
    setStartDate(nextStartDate);
  }

  function handleSetEndDate(date: string) {
    nextEndDate = date;
    setEndDate(nextEndDate);

    dispatch({
      type: 'setPostFilter',
      value: {
        published_after: moment(nextStartDate).unix(),
        published_before: moment(nextEndDate).add(1, 'days').unix(),
      },
    });
  }

  function onClickClearFilters() {
    setDateRange(DateRange.Last90Days);
    return dispatch({ type: 'clearFilters' });
  }

  return (
    <Paper square sx={styles.toolbar}>
      <Grid container spacing={2} alignItems="center" justifyContent="space-between">
        <Grid xs={6} container>
          <Grid>
            <RangePickerWrapper>
              <DatePickers.Range
                dateRange={dateRange}
                startDate={startDate}
                endDate={endDate}
                onSetStart={handleSetStartDate}
                onSetEnd={handleSetEndDate}
                onSetRange={setDateRange}
                includeToday
              />
            </RangePickerWrapper>
          </Grid>

          <Grid>
            <Filters />
          </Grid>
        </Grid>

        {hasFilters && (
          <Grid>
            <Button
              startIcon={<RefreshIcon />}
              variant="contained"
              color="secondary"
              size="large"
              onClick={onClickClearFilters}
            >
              {t('analytics:clearFilters')}
            </Button>
          </Grid>
        )}
      </Grid>

      <Chips />
    </Paper>
  );
};

export default SearchFilterBar;
